import type { ActionViewT } from "@/types/database/actions";
import type { EntryViewT } from "@/types/database/entries";
import type { ExtendedEventViewT } from "@/types/database/events";
import type { SizeT } from "@/types/zod/common";

import ObservationEntryCard from "../../../../entries/components/ObservationEntryCard";
import TrackerEntryCard from "../../../../entries/components/TrackerEntryCard";
import EventCard from "../../../../events/components/EventCard";
import NoDataPlaceholder from "@/components/common/NoDataPlaceholders";
import ActionCard from "./ActionCard";

interface BaseLogT {
	type: string;
	log_id: string;
	date: string;
	[key: string]: unknown;
}

interface Props {
	diaryId: string;
	diaryHistory: BaseLogT[];
	size?: SizeT;
	editable?: boolean;
}

const History = ({ diaryId, diaryHistory, size, editable }: Props) => {
	// Ensure diaryHistory is sorted by date
	const sortedHistory = [...diaryHistory].sort((a, b) => {
		const aDate = new Date(a.date);
		const bDate = new Date(b.date);
		return bDate.getTime() - aDate.getTime(); // Sort in descending order (newest first)
	});

	if (!sortedHistory || sortedHistory.length === 0) {
		return <NoDataPlaceholder />;
	}

	return (
		<div className="space-y-4">
			{sortedHistory.map((log) => {
				switch (log.type) {
					case "entry":
						return (
							<TrackerEntryCard
								key={log.log_id}
								entry={log as unknown as EntryViewT}
								size={size}
								editable={editable}
							/>
						);
					case "observation":
						return (
							<ObservationEntryCard
								key={log.log_id}
								entry={log as unknown as EntryViewT}
								size={size}
								editable={editable}
							/>
						);
					case "event":
						return (
							<EventCard
								key={log.log_id}
								event={log as unknown as ExtendedEventViewT}
								size={size}
								editable={editable}
							/>
						);
					case "action":
						return (
							<ActionCard
								key={log.log_id}
								action={log as unknown as ActionViewT}
								size={size}
							/>
						);
					default:
						return null;
				}
			})}
		</div>
	);
};

export default History;
